<template>
  <section>
    <AppPageTitleBar
      :title="route.meta.title"
      :back-to="backTo"
      back-label="Natrag"
    />

    <VehicleForm
      v-if="!isEditMode || vehicleToEdit"
      v-model:is-status-warning-open="isStatusWarningOpen"
      :initial-vehicle-values="vehicleToEdit"
      :is-saving-vehicle="isSavingVehicle"
      submit-text="Prihvati"
      @submit="saveVehicleAsync"
    />
  </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import AppPageTitleBar from '../../components/AppPageTitleBar.vue'
import VehicleForm from '../../components/VehicleForm.vue'
import { apiClient } from '../../services/apiClient'
import { showRequestErrorToast, showSuccessToast } from '../../store/appStore'

const route = useRoute()
const router = useRouter()
const isEditMode = computed(() => Boolean(route.params.vehicleId))
const isSavingVehicle = ref(false)
const isStatusWarningOpen = ref(false)
const vehicleToEdit = isEditMode.value
  ? window.history.state?.vehicle ?? null
  : null

const backTo = computed(() => isEditMode.value
  ? {
      name: 'inventory-vehicle-detail',
      params: { vehicleId: route.params.vehicleId },
      state: { vehicle: vehicleToEdit },
    }
  : { name: 'inventory-vehicles' })

async function saveVehicleAsync (vehicleFormValues) {
  if (isSavingVehicle.value) {
    return
  }

  isSavingVehicle.value = true

  try {
    const savedVehicle = await apiClient.postAsync(
      isEditMode.value ? `/api/vehicles/${route.params.vehicleId}` : '/api/vehicles',
      vehicleFormValues
    )

    showSuccessToast(isEditMode.value
      ? 'Vozilo je uspješno spremljeno.'
      : 'Vozilo je uspješno uneseno.')

    await router.push({
      name: 'inventory-vehicle-detail',
      params: {
        vehicleId: savedVehicle.id,
      },
      state: { vehicle: savedVehicle },
    })
  } catch (error) {
    console.error(`Failed to ${isEditMode.value ? 'save' : 'create'} vehicle.`, error)

    if (error.status === 409 && error.data?.error === 'vehicle_has_reservations') {
      isStatusWarningOpen.value = true
    } else {
      showRequestErrorToast(
        error,
        isEditMode.value
          ? 'Vozilo nije bilo moguće spremiti.'
          : 'Vozilo nije bilo moguće unijeti.'
      )
    }
  } finally {
    isSavingVehicle.value = false
  }
}
</script>
